﻿export interface ServiceItem {
  id: string;
  slug: string;
  title: string;
  desc: string;
  detail: string[];
  img: string;
  icon: string;
}

export const SERVICES: ServiceItem[] = [
  {
    id: '01',
    slug: 'motor-ve-mekanik-bakim-onarim',
    title: 'Motor ve Mekanik Bakım & Onarım',
    desc: 'Motor ve mekanik sistemlerinizi aracın marka ve teknik yapısına uygun şekilde detaylı inceliyoruz. Doğru teşhis, kaliteli parça ve uzman müdahale ile uzun ömürlü, güvenli çözümler sunuyoruz.',
    detail: ['Motor revizyon ve onarım', 'Mekanik sistem kontrolleri', 'Yağ ve soğutma bakımı', 'Kayış/zincir takibi', 'Performans ve güvenlik testi'],
    img: '/images/cg-svc-engine.jpg',
    icon: 'ri-settings-3-line',
  },
  {
    id: '02',
    slug: 'dsg-sanziman-bakim-onarim',
    title: 'DSG Şanzıman Bakım & Onarım',
    desc: 'DSG şanzıman sistemlerinizi detaylı analiz ve doğru teşhis ile ele alıyoruz. Uzman müdahale ile sarsıntı, vuruntu ve performans kaybı gibi sorunlara kalıcı çözümler üretiyoruz.',
    detail: ['DSG yağ ve bakım', 'Adaptasyon ve test', 'Valf ünitesi ve hidrolik kontrol', 'Mekatronik teşhis', 'Onarım sonrası kalite kontrolü'],
    img: '/images/kiiii.png?v=3',
    icon: 'ri-tools-line',
  },
  {
    id: '03',
    slug: 'kinergo-guclendirilmis-basinc-tupu',
    title: 'Kinergo Güçlendirilmiş Basınç Tüpü',
    desc: 'Yüksek basınç altında çalışan sistemler için güvenli ve dayanıklı çözümler sunuyoruz. Standart tüplere kıyasla daha uzun ömürlü ve performans odaklı kullanım sağlıyoruz.',
    detail: ['Basınç tüpü uygunluk kontrolü', 'Profesyonel uygulama', 'Sistem basınç testi', 'DSG uyum kontrolü', 'Garanti kapsamında destek'],
    img: '/images/bt2.png?v=2',
    icon: 'ri-drop-line',
  },
  {
    id: '04',
    slug: 'alt-takim-bakim-onarim',
    title: 'Alt Takım Bakım & Onarım',
    desc: 'Alt takım sistemlerinizi sürüş güvenliği ve yol tutuşu odağında detaylı kontrol ediyoruz. Doğru teşhis ve uzman müdahale ile titreşim, ses ve dengesizlik sorunlarına kalıcı çözümler sunuyoruz.',
    detail: ['Amortisör ve yay', 'Rot, rotil ve burç', 'Salıncak ve takoz', 'Rot balans desteği', 'Test sürüşü'],
    img: '/images/cg-svc-susp.jpg',
    icon: 'ri-car-line',
  },
  {
    id: '05',
    slug: 'ariza-tespit-hizmeti',
    title: 'Arıza Tespit Hizmeti',
    desc: 'Arıza tespit sürecimiz gelişmiş diagnostik sistemler ve uzman teknik ekiple yürütülür. Sorunun kaynağını doğru belirleyerek gereksiz parça değişimlerinin önüne geçiyoruz.',
    detail: ['VCDS ve ODIS destekli tarama', 'Arıza kodu analizi', 'Adaptasyon ve sıfırlama', 'Canlı veri izleme', 'Çözüm önerisi ve rapor'],
    img: '/images/cg-svc-diag.jpg',
    icon: 'ri-scan-line',
  },
  {
    id: '06',
    slug: 'periyodik-bakim',
    title: 'Periyodik Bakım',
    desc: 'Periyodik bakım işlemlerini aracın marka standartları ve kullanım koşullarına göre uyguluyoruz. Düzenli kontrollerle performans, güvenlik ve sürüş konforunu koruyoruz.',
    detail: ['Motor yağı ve filtreler', 'Hava/yakıt/kabin filtresi', 'Fren ve sıvı kontrolleri', 'Kayış ve rulman kontrolü', 'Bakım kaydı'],
    img: '/images/cg-svc-perio.jpg',
    icon: 'ri-calendar-check-line',
  },
  {
    id: '07',
    slug: 'kavrama-volan-degisimi',
    title: 'Kavrama & Volan Değişimi',
    desc: 'Kavrama ve volan sistemlerini sürüş konforu ve şanzıman sağlığı odağında profesyonel yeniliyoruz. Doğru parça ve uzman montaj ile titreme, sarsıntı ve güç kaybını kalıcı şekilde gideriyoruz.',
    detail: ['Kavrama seti değişimi', 'Volan kontrolü ve değişimi', 'Biyel ve yatak kontrolü', 'Vites geçiş kalibrasyonu', 'Sürüş testi'],
    img: '/images/svc-trans-det.jpg',
    icon: 'ri-steering-2-line',
  },
  {
    id: '08',
    slug: 'carbon-clean-hizmeti',
    title: 'Carbon Clean Hizmeti',
    desc: 'Carbon Clean işlemi motor içinde biriken karbon tortularını temizleyerek performansın yeniden kazanılmasını sağlar. Yakıt verimliliği, motor tepkisi ve sürüş konforu gözle görülür şekilde iyileşir.',
    detail: ['Karbon birikimi değerlendirmesi', 'Profesyonel temizlik uygulaması', 'Emisyon ve rölanti kontrolü', 'Test sürüşü', 'Bakım önerileri'],
    img: '/images/cc.jpeg',
    icon: 'ri-flashlight-line',
  },
  {
    id: '09',
    slug: 'arac-check-up-hizmeti',
    title: 'Araç Check-up Hizmeti',
    desc: 'Check-up hizmetimiz aracınızın kritik sistemlerinin kapsamlı kontrolünü sağlar. Olası arızaları erkenden tespit ederek güvenli ve sorunsuz sürüşe katkı sunarız.',
    detail: ['Genel mekanik kontrol', 'Fren ve alt takım', 'Elektronik ön tarama', 'Sıvı ve aydınlatma', 'Özet rapor'],
    img: '/images/yenigorsel/y10.jpg',
    icon: 'ri-file-list-3-line',
  },
];
